// src/data/rolesByUniverse.ts
// Defines the role categories for each universe.
// Add-only update: Black Clover roles are universal and balanced.

export const rolesByUniverse: Record<string, string[]> = {
  naruto: [
    "Captain",
    "Vice Captain",
    "Support 1",
    "Support 2",
    "Tank",
    "Healer",
    "Eyes",
    "IQ",
    "Summon",
    "Jutsu",
    "Clan",
    "Chakra",
    "Sensei",
    "Speed",
    "Taijutsu"
  ],

  bleach: [
    "Captain",
    "Vice Captain",
    "Support 1",
    "Support 2",
    "Tank",
    "Healer",
    "Zanpakuto",
    "Reiatsu",
    "Bankai",
    "Resurreccion",
    "Vollstandig",
    "Fullbring",
    "Speed",
    "IQ",
    "Sensei",
    "Ally",
  ],

  dragonball: [
    "Captain",
    "Vice Captain",
    "Support 1",
    "Support 2",
    "Tank",
    "Healer",
    "Ki Control",
    "Technique",
    "Form",
    "Speed",
    "IQ",
    "Sensei",
    "Power Level",
    "Energy Manipulation",
    "Martial Arts"
  ],
  
  blackclover: [
    "Captain",
    "Vice Captain",
    "Support 1",
    "Support 2",
    "Tank",
    "Healer",
    "Magic Power",       // total mana output
    "Grimoire Skill",    // mastery of spells / pages
    "Combat Skill",      // physical & weapon ability
    "Mana Control",      // precision and finesse with magic
    "Speed",             // movement and casting speed
    "IQ",                // tactical or strategic sense
    "Squad Synergy",     // teamwork and leadership compatibility
    "Transformation",    // covers devil, elf, mana zone, etc.
    "Experience",        // battle-tested rank / veteran level
    "Willpower"          // inner drive and resolve
  ],

 mha: [
  "Captain",
  "Vice Captain",
  "Support 1",
  "Support 2",
  "Tank",
  "Healer",
  "Quirk Power",
  "Quirk Control",
  "Quirk Versatility",
  "Combat Skill",
  "IQ",
  "Speed",
  "Resolve",
  "Teamwork",
  "Mentor"
],

sololeveling: [
  "Captain",
  "Vice Captain",
  "Support 1",
  "Support 2",
  "Tank",
  "Healer",
  "Aura",
  "Combat Power",
  "Speed",
  "Mana Output",
  "Summon",
  "IQ",
  "Rank"
],

  jjk: [
    "Captain",
    "Vice Captain",
    "Healer",
    "Support 1",
    "Support 2",
    "Tank",
    "Domain Expansion",
    "Cursed Spirit",
    "Cursed Energy",
    "Combat Specialist",
    "Technique Specialist",
    "Grade",
    "IQ",
    "Speed"
  ],

  "7deadlysins": [
    "Captain",
    "Vice Captain",
    "Tank",
    "Healer",
    "Support 1",
    "Support 2",
    "Demon Form",
    "Goddess Blessing",
    "Chaos User",
    "Combat Power",
    "Speed",
    "Magic Specialist",
    "IQ",
    "Willpower"
  ],

 onepiece: [
    "Captain",
    "Vice Captain", 
    "Support 1",
    "Support 2",
    "Tank",
    "Healer",
    "Devil Fruit",      // power, versatility, awakening
    "Haki",             // Observation, Armament, Conqueror's mastery
    "Combat Power",     // raw strength, destructive capability
    "Speed",            // movement, reactions, blitzing
    "Weapon Skill",     // swordsmanship, marksmanship, technique
    "IQ",               // battle IQ, strategy, adaptability
    "Willpower"         // resolve, conqueror's spirit, mental strength
  ],
  onepunchman: [
      "Captain",
      "Vice Captain",
      "Support 1",
      "Support 2",
      "Tank",
      "Healer",
      "Hero Rank",
      "Threat Level",
      "Combat Power",
      "Speed",
      "Technique",
      "Energy",
      "IQ",
      "Willpower"
  ],

  demonslayer: [
    "Captain",
    "Vice Captain",
    "Support 1",
    "Support 2",
    "Tank",
    "Healer",
    "Speed",
    "Power",
    "IQ",
    "Breathing",
    "Demon",
    "Hashira",
    "Weapon Skill",
    "Technique"
  ],

  hunterxhunter: [
    "Captain",
    "Vice Captain",
    "Support 1",
    "Support 2",
    "Tank",
    "Healer",
    "Nen Type",
    "Aura Control",
    "Combat Power",
    "Speed",
    "Technique",
    "IQ",
    "Willpower",
  ],

  crossdraft: [
    "Captain",
    "Vice Captain",
    "Support 1",
    "Support 2",
    "Tank",
    "Healer",
    "Speed",
    "IQ",
    "Power",
    "Hax",
    "Defence",
  ],

  factiondraft: [
    "Captain",
    "Vice Captain",
    "Support 1",
    "Support 2",
    "Tank",
    "Healer",
    "Speed",
    "IQ",
    "Power",
    "Hax",
    "Defence",
  ],

  // Boruto uses the same ninja roles as Naruto.
  boruto: [
    "Captain",
    "Vice Captain",
    "Support 1",
    "Support 2",
    "Tank",
    "Healer",
    "Eyes",
    "IQ",
    "Summon",
    "Jutsu",
    "Clan",
    "Chakra",
    "Sensei",
    "Speed",
    "Taijutsu"
  ],
};

export default rolesByUniverse;
